import React from 'react';

import Icon, { IconVariant } from 'components/Icon/Icon';

interface MetaWrapperProps {
  icon?: JSX.Element;
  name?: string;
}

const MetaWrapper = ({ icon, name }: MetaWrapperProps) => (
  <div className="flex items-center gap-1">
    {icon && <Icon icon={icon} variant={IconVariant.SMALL} />}
    <div className="prose-body-sm-reg text-kira-slate-700">{name}</div>
  </div>
);

export default MetaWrapper;
